import { isArray, isString } from 'lodash';
import { Setting, SettingGroup } from '../model/setting';

export interface SettingsMap {
    [key: string]: any;
}


export function getSetting(key: string, settinsMap: SettingsMap, defaultSettingsMap: SettingsMap): string | null {
    let value: any = settinsMap[key];
    if (value == null)
        value = defaultSettingsMap[key]?.default;
    if (value != null)
        return value;
    return null;
}

export function getSettingArray(key: string, settinsMap: SettingsMap, defaultSettingsMap: SettingsMap): string[] | null {
    let value: any = settinsMap[key];
    if (value == null)
        value = defaultSettingsMap[key]?.default;
    if (isArray(value))
        return value?.filter(obj => obj !== '');
    else if (isString(value))
        return value.split(',')?.filter(obj => obj !== '');
    return null;
}

export function getSettingsGroups(settings: SettingGroup[]): string[] {
    return settings.map(group => group.name);
}

export function getSettingsOfSettingsGroup(groupName: string, settings: SettingGroup[]): Setting[] {
    if (!groupName) groupName = getSettingsGroups(settings)[0];

    return settings
        .filter(group => group.name == groupName)
        .map(group => group.settings)
        .find(s => s);
}


export function getSettingAsNumber(key: string, settinsMap: SettingsMap, defaultSettingsMap: SettingsMap): number | null {
    let value: any = settinsMap[key];
    if (value == null)
        value = defaultSettingsMap[key]?.default;
    if (value != null) {
        const parsedValue = +value;
        if (!isNaN(parsedValue))
            return parsedValue;
    }
    return null;
}

export function getSettingAsBoolean(key: string, settinsMap: SettingsMap, defaultSettingsMap: SettingsMap): boolean | null {
    let value: any = settinsMap[key];
    if (value == null)
        value = defaultSettingsMap[key]?.default;
    if (value != null) {
        switch (value) {
            case true:
            case '1':
            case 'true':
                return true;
            default:
                return false;
        }
    }
    return null;
}
